export default __webpack_public_path__ + "static/media/Inter-Regular.cdb5712a.woff2";